import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { Variables } from "../../Variables1/Variables";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
const MetaData = () => {
    let { PageId } = useParams();
    let navigate = useNavigate();
    const [formData, setFormData] = useState([]);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [keywords, setKeywords] = useState("");
    const [url, setUrl] = useState("");
    const [selectedPage, setSelectedPage] = useState("");
    const [imageFile, setImageFile] = useState(null);
    const [image, setImage] = useState(null);
    const [MetaDataId, setMetaDataId] = useState(0);

    function IsValid() {
        const showError = (fieldId, message) => {
            if (fieldId) {
                const element = document.getElementById(fieldId);
                if (element) element.classList.add("required");
            }
            toast.error(message);
            return false;
        };

        if (!title.trim()) return showError("title", "Title is required");
        if (!description.trim()) return showError("description", "Description is required");
        if (!keywords.trim()) return showError("keywords", "Keywords are required");
        if (!url.trim()) return showError("url", "URL is required");
        if (!selectedPage || selectedPage === 0) return showError("selectedPage", "Page is required");

        const validateImageFile = (file) => {
            if (!file) return showError(null, "Image is required");
            if (file.size > 2000000) return showError(null, "Image size should be less than 2MB");
            if (!file.type.startsWith("image/")) return showError(null, "Please upload a valid image file");
            return true;
        };

        if (MetaDataId === 0) {
            return validateImageFile(imageFile);
        } else {
            if (!image || image.trim() === "") {
                return validateImageFile(imageFile);
            }
        }

        return true;
    }


    const HandleSubmit = async () => {
        if (!IsValid()) return;

        const formDataToSend = new FormData();
        formDataToSend.append("MetaDataId", MetaDataId);
        formDataToSend.append("Title", title);
        formDataToSend.append("Description", description);
        formDataToSend.append("Keywords", keywords);
        formDataToSend.append("Url", url);
        formDataToSend.append("Page", selectedPage);
        if (imageFile) {
            formDataToSend.append("imageFile", imageFile);
        }

        let URL = Variables.API_URL + "MetaData/Add";
        let response = await fetch(URL, {
            method: "POST",
            headers: {
                Accept: "application/json",

            },
            body: formDataToSend,
        });
        let result = await response.json();
        if (response.ok) {
            toast.success(result.message);
        } else {
            toast.error(result.message || "An error occurred while saving metadata.");
        }
    };


    async function GetMetaData(id) {
        const URL = Variables.API_URL + "MetaData/GetMetaData/" + id;
        const response = await fetch(URL, {
            headers: {
                Accept: "application/json",

            },
        });
        if (!response.ok) throw Error("Did Not Receive expected data");
        const listItems = await response.json();
        setMetaDataId(listItems.MetaDataId ?? null);
        setDescription(listItems.Description ?? "");
        setKeywords(listItems.Keywords ?? "");
        setUrl(listItems.Url ?? "");
        setTitle(listItems.Title ?? "");
        setImage(listItems.Image ?? "");
    }

    async function GetFormData() {
        const URL = Variables.API_URL + "MetaData/GetFormData";
        const response = await fetch(URL, {
            method: "POST",
            headers: {
                Accept: "application/json",

            },
        })
        if (!response.ok) throw Error("Did Not Receive expected data");
        const listItems = await response.json();
        setFormData(listItems);
    }

    useEffect(() => {
        GetFormData();
    }, []);

    useEffect(() => {
        if (PageId) {
            setMetaDataId(0);
            setTitle("");
            setDescription("");
            setKeywords("");
            setUrl("");
            setImage(null);
            setImageFile(null);

            setSelectedPage(Number(PageId));
            GetMetaData(PageId);
        }
    }, [PageId]);


    return (
        <div className="rightSide">
            <div className="container-fluid mt-3">
                <div className="row">
                    <div className="col-12">
                        <h2>{MetaDataId == "0" ? "Add" : "Update"} SEO</h2>

                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {/* <form> */}
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <h3>{title}</h3>
                                    </div>
                                    <div className="col-lg-4 text-right">
                                        <button
                                            type="submit"
                                            className="btn btn-primary ms-2"
                                            onClick={HandleSubmit}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-lg-12 mb-3">
                                                <label className="mb-2">Title</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="title"
                                                    value={title}
                                                    maxLength={60}
                                                    onChange={(e) => {
                                                        if (e.target.value.length <= 60) {
                                                            setTitle(e.target.value);
                                                        }
                                                    }}
                                                />
                                                <small
                                                    style={{
                                                        color:
                                                            title.length <= 25
                                                                ? "red"
                                                                : title.length < 50
                                                                    ? "orange"
                                                                    : "green",
                                                    }}
                                                >
                                                    {title.length}/60 {title.length < 50 && "(Recommended: 50–60)"}
                                                </small>
                                            </div>

                                            <div className="col-lg-12 mb-3">
                                                <label className="mb-2">Description</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="description"
                                                    value={description}
                                                    maxLength={160}
                                                    onChange={(e) => {
                                                        if (e.target.value.length <= 160) {
                                                            setDescription(e.target.value);
                                                        }
                                                    }}
                                                />
                                                <small
                                                    style={{
                                                        color:
                                                            description.length <= 50
                                                                ? "red"
                                                                : description.length < 150
                                                                    ? "orange"
                                                                    : "green",
                                                    }}
                                                >
                                                    {description.length}/160{" "}
                                                    {description.length < 150 && "(Recommended: 150–160)"}
                                                </small>
                                            </div>

                                            <div className="col-lg-12">
                                                <label className="mb-2">Keywords </label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="keywords"
                                                    value={keywords}
                                                    onChange={(e) => setKeywords(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-lg-12 mb-3 mt-3">
                                                <label className="mb-2">Url</label>
                                                <input
                                                    className="form-control"
                                                    id="url"
                                                    value={url}
                                                    type="url"
                                                    onChange={(e) => setUrl(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-lg-12 mb-3">
                                                <label className="mb-2">Page</label>

                                                <select
                                                    className="form-control"
                                                    id="selectedPage"
                                                    value={selectedPage}
                                                    onChange={(e) => setSelectedPage(e.target.value)}
                                                    disabled={!!PageId}
                                                >
                                                    <option value={0}>Select Page</option>
                                                    {formData.map((r) => (
                                                        <option key={r.Id} value={r.Id}>
                                                            {r.Name}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                            <div className="col-lg-12 mb-3">
                                                <label className="mb-2">Image</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={(e) => setImageFile(e.target.files[0])}
                                                />
                                                {MetaDataId != 0 && image &&
                                                    <img
                                                        alt="media"
                                                        className="form-control"
                                                        style={{ width: "200px", height: "200px", objectFit: "cover" }}
                                                        src={Variables.imagePath.replace("/api", "") + image}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
};

export default MetaData;
